var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import InputNumber from 'antd/lib/input-number';
import Tooltip from 'antd/lib/tooltip';
import Radio from 'antd/lib/radio';
import AntIcon from 'antd/lib/icon';
import { TweenOneGroup } from 'rc-tween-one';
import Icon from './common/Icon';
import AutoComplete from './common/AutoComplete';
import RowHelp from './common/RowHelp';
import BoxModel from './common/BoxModel';
// import Slider from './common/Slider';
import { getOption, getParentNode } from '../utils';
var RadioButton = Radio.Button;
var RadioGroup = Radio.Group;
var Panel = Collapse.Panel;
var EditorInterface = /** @class */ (function (_super) {
    __extends(EditorInterface, _super);
    function EditorInterface() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (key, v, isDrag) {
            var _a;
            var value = key === 'offset' ? __assign(__assign({}, _this.props.value), v) : __assign(__assign({}, _this.props.value), (_a = {}, _a[key] = v, _a));
            _this.props.onChange('interface', value, isDrag);
        };
        return _this;
    }
    EditorInterface.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, locale = _a.locale, props = __rest(_a, ["value", "locale"]);
        var posChild = value.position !== 'static' ? (React.createElement("div", { key: "pos", style: { overflow: 'hidden' } },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    locale.position,
                    " - top, right, bottom, left")),
            React.createElement(BoxModel, { keys: ['top', 'right', 'bottom', 'left'], value: {
                    top: value.top,
                    right: value.right,
                    bottom: value.bottom,
                    left: value.left,
                }, onChange: function (e) {
                    _this.onChange('offset', e);
                } }),
            React.createElement(Row, { gutter: 8, style: { marginBottom: 0, marginTop: 28 } },
                React.createElement(Col, { span: 4, offset: 5 }, "zIndex"),
                React.createElement(Col, { span: 7 },
                    React.createElement(InputNumber, { min: 0, size: "small", style: { width: '100%' }, value: value.zIndex, onChange: function (e) {
                            _this.onChange('zIndex', e);
                        } })),
                React.createElement(Col, { span: 3 },
                    React.createElement(Tooltip, { arrowPointAtCenter: true, title: locale.zIndex },
                        React.createElement(AntIcon, { type: "question-circle" })))))) : null;
        var floatChild = value.position === 'static' || value.position === 'relative' ? (React.createElement("div", { key: "float", style: { overflow: 'hidden' } },
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "float", prompt: locale.float })),
                React.createElement(Col, { span: 21 },
                    React.createElement(RadioGroup, { value: value.float, size: "small", onChange: function (e) {
                            _this.onChange('float', e.target.value);
                        } }, Object.keys(locale.floatSelect).map(function (key) { return (React.createElement(RadioButton, { value: key, key: key },
                        React.createElement(Icon, { type: key === 'none' ? 'float-close' : "float-" + key, prompt: locale.floatSelect[key] }))); })))),
            React.createElement(Row, { gutter: 8, style: { marginBottom: 0 } },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "minus-circle", prompt: locale.clear })),
                React.createElement(Col, { span: 21 },
                    React.createElement(RadioGroup, { value: value.clear, size: "small", onChange: function (e) {
                            _this.onChange('clear', e.target.value);
                        } }, Object.keys(locale.clearSelect).map(function (key) { return (React.createElement(RadioButton, { value: key, key: key },
                        React.createElement(Icon, { type: key === 'none' ? 'float-close' : "clear-" + key, prompt: locale.clearSelect[key] }))); })))))) : null;
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "overflow", prompt: locale.overflow })),
                React.createElement(Col, { span: 21 },
                    React.createElement(Select, { style: { width: '100%' }, value: value.overflow, size: "small", onChange: function (e) {
                            _this.onChange('overflow', e);
                        }, getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); }, dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown" }, getOption(locale.overflowSelect, true)))),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "width", prompt: locale.width })),
                React.createElement(Col, { span: 9 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, value: value.width, onChange: function (e) {
                            _this.onChange('width', e);
                        } })),
                React.createElement(Col, { span: 6 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, placeholder: "min", value: value.minWidth, onChange: function (e) {
                            _this.onChange('minWidth', e);
                        } })),
                React.createElement(Col, { span: 6 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, placeholder: "max", value: value.maxWidth, onChange: function (e) {
                            _this.onChange('maxWidth', e);
                        } }))),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "height", prompt: locale.height })),
                React.createElement(Col, { span: 9 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, value: value.height, onChange: function (e) {
                            _this.onChange('height', e);
                        } })),
                React.createElement(Col, { span: 6 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, placeholder: "min", value: value.minHeight, onChange: function (e) {
                            _this.onChange('minHeight', e);
                        } })),
                React.createElement(Col, { span: 6 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, placeholder: "max", value: value.maxHeight, onChange: function (e) {
                            _this.onChange('maxHeight', e);
                        } }))),
            React.createElement(RowHelp, { title: React.createElement(Icon, { type: "position", prompt: locale.position }), help: locale.position_help },
                React.createElement(Select, { style: { width: '100%' }, value: value.position, size: "small", onChange: function (e) {
                        _this.onChange('position', e);
                    }, getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); }, dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown" }, getOption(locale.positionSelect, true))),
            React.createElement(TweenOneGroup, { enter: { height: 0, type: 'from', duration: 300, ease: 'easeInOutCirc' }, leave: { height: 0, duration: 300, ease: 'easeInOutCirc' }, style: { overflow: 'hidden' } }, floatChild),
            React.createElement(TweenOneGroup, { enter: { height: 0, type: 'from', duration: 300, ease: 'easeInOutCirc' }, leave: { height: 0, duration: 300, ease: 'easeInOutCirc' }, style: { overflow: 'hidden' } }, posChild)));
    };
    EditorInterface.propTypes = {
        className: PropTypes.string,
        header: PropTypes.string,
        value: PropTypes.object,
        onChange: PropTypes.func,
        locale: PropTypes.object,
    };
    EditorInterface.defaultProps = {
        className: 'editor-font',
        value: {
            overflow: 'visible',
            width: '0px',
            maxWidth: null,
            minWidth: null,
            position: 'static',
            top: null,
            right: null,
            bottom: null,
            left: null,
        },
        onChange: function () { },
    };
    return EditorInterface;
}(Component));
export default EditorInterface;
EditorInterface.componentName = 'EditorInterface';
